/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ReferenceDataLevel {
  Local = 'Local',
  Release = 'Release',
  Protect = 'Protect'
}
